import type { paths } from "@/api-schema";
import { alphartisApiAxios } from "@/config/axios";
import { useQuery } from "@tanstack/react-query";
import { optionsWithDefaults } from "../_helpers/options-with-defaults";
import { Options } from "../_types";

export const OCCUPATION_BY_UUID_RESOURCE = "occupation" as const;
export const OCCUPATION_BY_UUID_API_PATH = `/v1/${OCCUPATION_BY_UUID_RESOURCE}/{uuid}` as const;

export type OccupationByUuidParameters = paths[typeof OCCUPATION_BY_UUID_API_PATH]["get"]["parameters"]["query"];
export type OccupationByUuidResponse =
  paths[typeof OCCUPATION_BY_UUID_API_PATH]["get"]["responses"][200]["content"]["application/json"];

export function useOccupationByUuidQuery(uuid: string, options?: Options<OccupationByUuidParameters, never>) {
  const optionsWithDefaultsResolved = optionsWithDefaults<Options<OccupationByUuidParameters, never>>(options);

  const requestParameters = {
    ...(optionsWithDefaultsResolved.parameters || {}),
    extend: optionsWithDefaultsResolved.parameters?.extend || [],
  };

  return useQuery({
    enabled: !!uuid,
    queryKey: [OCCUPATION_BY_UUID_RESOURCE, uuid, { parameters: requestParameters }],
    queryFn: async () => {
      const response = await alphartisApiAxios.get<OccupationByUuidResponse>(
        `/v1/${OCCUPATION_BY_UUID_RESOURCE}/${uuid}`,
        {
          params: requestParameters,
        },
      );

      return response.data;
    },
  });
}
